// extracted by mini-css-extract-plugin
export var modalFooter = "_sb-0";